import { IdFilter, StringFilter } from 'core/filters';
import { ModelFilter } from 'core/models';


export class FileTemplateFilter extends ModelFilter {
    public id?: IdFilter = new IdFilter();
    public code?: StringFilter = new StringFilter();
    public name?: StringFilter = new StringFilter();
    public siteId?: IdFilter = new IdFilter();
    public menuId?: IdFilter = new IdFilter();
    public pageId?: IdFilter = new IdFilter();
    public url?: StringFilter = new StringFilter();
    public fileName?: StringFilter = new StringFilter();
    public selfDefineInputId?: IdFilter = new IdFilter();
    public defaultId?: IdFilter = new IdFilter();
    public statusId?: IdFilter = new IdFilter();
}
